<template>
  <component :is="commissionPlanData.id === undefined ? 'div' : 'div'">
    <commission-plan-item-add-new
      :is-add-new-commission-plan-items-sidebar-active.sync="isAddNewCommissionPlanItemsSidebarActive"
      :products-options="productsOptions"
      :plan-id="commissionPlanData.id"
      @refetch-data="refreshItemsTable"
    />
    <commission-plan-item-edit
      :is-edit-commission-plan-items-sidebar-active.sync="isEditCommissionPlanItemsSidebarActive"
      :products-options="productsOptions"
      :commission-plan-item-data="commissionPlanItemData"
      @refetch-data="refreshItemsTable"
    />
    <template #title>
      <feather-icon
        icon="UserIcon"
        size="16"
        class="mr-0 mr-sm-50"
      />
      <span class="d-none d-sm-inline">Informatie</span>
    </template>

    <template v-if="commissionPlanData">
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <b-form
          class="mb-2"
          @submit.prevent="handleSubmit(updateCommisionPlan)"
        >
          <b-card>

            <div class="d-flex mb-1">
              <feather-icon
                icon="UserIcon"
                size="19"
              />
              <h4 class="mb-0 ml-50">
                Informatie
              </h4>
            </div>
            <b-row>

              <!-- Field: ID -->
              <b-col
                cols="12"
                md="2"
              >
                <b-form-group
                  label="ID"
                  label-for="id"
                >
                  <b-form-input
                    id="id"
                    v-model="commissionPlanData.id"
                    readonly="readonly"
                  />
                </b-form-group>
              </b-col>
              <!-- Field: Name -->
              <b-col
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="validationContext"
                  name="name_plan"
                  rules="required"
                >
                  <b-form-group
                    label="Naam"
                    label-for="name_plan"
                  >
                    <b-form-input
                      id="name_plan"
                      v-model="commissionPlanData.name"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
              >
                <b-button
                  v-if="$can('update', 'commission-plan')"
                  variant="primary"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  type="submit"
                >
                  <span>Opslaan</span>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </validation-observer>
      <b-row>

        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >

          <template>

            <!-- Table Container Card -->
            <b-card
              no-body
            >

              <div class="m-2">
                <!-- Table Top -->
                <b-row>
                  <b-col
                    cols="12"
                  >
                    <div class="d-flex mb-1">
                      <feather-icon
                        icon="UserIcon"
                        size="19"
                      />
                      <h4 class="mb-0 ml-50">
                        Commissie regels
                      </h4>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <!-- Per Page -->
                  <b-col
                    cols="12"
                    md="6"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                  />
                  <!-- Add -->
                  <b-col
                    class="d-flex align-items-center justify-content-end"
                    cols="12"
                    md="6"
                  >
                    <b-button
                      v-if="$can('create', 'commission-plan')"
                      variant="primary"
                      @click="isAddNewCommissionPlanItemsSidebarActive = true"
                    >
                      Toevoegen
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              <b-table
                ref="refCommissionPlansListItemsTable"
                :items="commissionPlanData.items"
                responsive
                :fields="tableColumnsItems"
                primary-key="id"
                :sort-by.sync="sortByItems"
                :sort-desc.sync="isSortDirDescItems"
                show-empty
                empty-text="Geen overeenkomende records gevonden"
                class="position-relative categorie-table"
              >

                <!-- Column: Id -->
                <template #cell(id)="data">
                  <b-link
                    class="font-weight-bold"
                    @click="setCommissionPlanItem(data.item.id)"
                  >
                    #{{ data.value }}
                  </b-link>
                </template>

                <template #cell(productID)="data">
                  <div class="text-nowrap">
                    <span class="align-text-top text-capitalize">{{ resolveProductName(data.item.productID) }}</span>
                  </div>
                </template>

                <template #cell(yearFrom)="data">
                  <div class="text-nowrap text-center">
                    <span class="align-text-top text-capitalize">{{ data.item.yearFrom }} </span>
                  </div>
                </template>

                <template #cell(yearTo)="data">
                  <div class="text-nowrap text-center">
                    <span class="align-text-top text-capitalize">{{ data.item.yearTo }} </span>
                  </div>
                </template>

                <template #cell(commissionPercentage)="data">
                  <div class="text-nowrap text-center">
                    <span class="align-text-top text-capitalize">{{ data.item.commissionPercentage }} %</span>
                  </div>
                </template>

                <!-- Column: Actions -->
                <template #cell(actions)="data">

                  <div class="text-nowrap">
                    <b-link
                      :id="`commission-plan-item-view-action-row-${data.item.id}`"
                      @click="setCommissionPlanItem(data.item.id)"
                    >
                      <feather-icon
                        :id="`commission-plan-item--row-${data.item.id}-preview-icon`"
                        class="cursor-pointer mx-1"
                        icon="EyeIcon"
                        size="16"
                      />
                    </b-link>
                    <b-tooltip
                      :target="`commission-plan-item--view-action-row-${data.item.id}`"
                      placement="top"
                    >
                      <p class="mb-0">
                        Aanpassen
                      </p>
                    </b-tooltip>
                    <feather-icon
                      :id="`commission-plan-item--row-${data.item.id}-delete-icon`"
                      class="cursor-pointer"
                      size="16"
                      icon="TrashIcon"
                      @click="confirmCommissionPlanItemDeleteText(data.item.id)"
                    />
                    <b-tooltip
                      :target="`commission-plan-item--row-${data.item.id}-delete-icon`"
                      placement="top"
                    >
                      <p class="mb-0">
                        Verwijderen
                      </p>
                    </b-tooltip>
                  </div>
                </template>

              </b-table>
            </b-card>

          </template>

        </b-col>

      </b-row>
      <b-row>
        <b-col
          cols="12"
        >
          <b-card>
            <b-row>
              <b-col
                cols="6 text-left"
              >
                <b-button
                  variant="secondary"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  type="button"
                  :to="{ name: 'app-locations-list' }"
                >
                  <span>Terug</span>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </template>

  </component>
</template>

<script>
import {
  BTab,
  BTabs,
  BCard,
  BAlert,
  BLink,
  BButton,
  BFormGroup,
  BFormInput,
  BForm,
  BFormTextarea,
  BRow,
  BCol,
  BFormInvalidFeedback, BTable, BTooltip,
} from 'bootstrap-vue'
import { onUnmounted, ref } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import { required } from '@validations'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import errorDefaultMessage from '@core/app-config/errorAndSuccesDefaultMessage'
import commissionPlanStoreModule from '@/views/pages/commission-plan/commissionPlanStoreModule'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { heightTransition } from '@core/mixins/ui/transition'
import useCommissionPlansList from '@/views/pages/commission-plan/useCommissionPlanList'
import CommissionPlanItemAddNew from '@/views/pages/commission-plan/commission-plan-item-add/CommissionPlanItemAddNew.vue'
import CommissionPlanItemEdit from '@/views/pages/commission-plan/commission-plan-item-edit/CommissionPlanItemEdit.vue'

export default {
  components: {
    CommissionPlanItemAddNew,
    CommissionPlanItemEdit,
    BButton,
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    BFormGroup,
    BFormInput,
    BForm,
    BFormTextarea,
    BRow,
    BCol,
    BFormInvalidFeedback,
    BCardActions,
    BTable,
    BTooltip,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      commissionPlanData: {
        id: null,
        name: '',
        items: [],
      },
      commissionPlanItemData: {},
      productsOptions: [],
    }
  },
  mounted() {
    this.getCommissionPlan()
  },
  beforeMount() {
    this.getProducts()
  },
  methods: {
    setCommissionPlanItem(id) {
      store.dispatch('app-commission-plan-edit/fetchCommissionPlanItem', id)
        .then(response => {
          this.commissionPlanItemData = response.data
          this.isEditCommissionPlanItemsSidebarActive = true
        })
        .catch(() => {
          this.commissionPlanItemData = {}
        })
    },
    getCommissionPlan() {
      store.dispatch('app-commission-plan-edit/fetchCommissionPlan', { id: router.currentRoute.params.id })
        .then(response => {
          this.commissionPlanData = response.data
        })
        .catch(() => {
          this.commissionPlanData = undefined
        })
    },
    getProducts() {
      store
        .dispatch('app-commission-plan-edit/fetchProducts', {
          sortBy: 'name',
          sortDesc: false,
        })
        .then(response => {
          this.productsOptions = response.data.items
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Ophalen Producten',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: `${errorDefaultMessage.fetchDataError}`,
            },
          })
        })
    },
    updateCommisionPlan() {
      store.dispatch('app-commission-plan-edit/updateCommissionPlan', { id: router.currentRoute.params.id, name: this.commissionPlanData.name })
        .then(() => {
          router.push({ name: 'app-commission-plan' })
        })
    },
    resolveProductName(id) {
      const filteredProduct = this.productsOptions.filter(product => product.id === id)
      if (filteredProduct.length > 0) {
        return filteredProduct[0].name
      }

      return ''
    },
    refreshItemsTable() {
      this.getCommissionPlan()
    },
    confirmCommissionPlanItemDeleteText(id) {
      this.$swal({
        title: 'Weet je het zeker?',
        text: 'U kunt dit niet meer terugdraaien!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, verwijder het!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          store.dispatch('app-commission-plan-edit/deleteCommissionPlanItem', { id })
            .then(() => {
              this.refreshItemsTable()
              this.$swal({
                icon: 'success',
                title: 'Verwijderd!',
                text: 'De commisie regel is verwijderd.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
        }
      })
    },
  },
  setup() {
    const COMMISSION_PLAN_EDIT_APP_STORE_MODULE_NAME = 'app-commission-plan-edit'
    const isAddNewCommissionPlanItemsSidebarActive = ref(false)
    const isEditCommissionPlanItemsSidebarActive = ref(false)

    // Register module
    if (!store.hasModule(COMMISSION_PLAN_EDIT_APP_STORE_MODULE_NAME)) store.registerModule(COMMISSION_PLAN_EDIT_APP_STORE_MODULE_NAME, commissionPlanStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(COMMISSION_PLAN_EDIT_APP_STORE_MODULE_NAME)) store.unregisterModule(COMMISSION_PLAN_EDIT_APP_STORE_MODULE_NAME)
    })

    const {
      fetchCommissionPlansItems,
      tableColumnsItems,
      perPageItems,
      currentPageItems,
      totalCommissionPlansItems,
      dataMetaItems,
      perPageOptionsItems,
      sortByItems,
      isSortDirDescItems,
      refCommissionPlansListItemsTable,
      showOverlayItems,
      refetchCommissionPlansItemsData,
    } = useCommissionPlansList()

    const {
      refFormObserver,
      getValidationState,
    } = formValidation()

    return {
      refFormObserver,
      getValidationState,
      avatarText,
      required,

      fetchCommissionPlansItems,
      tableColumnsItems,
      perPageItems,
      currentPageItems,
      totalCommissionPlansItems,
      dataMetaItems,
      perPageOptionsItems,
      sortByItems,
      isSortDirDescItems,
      refCommissionPlansListItemsTable,
      showOverlayItems,
      isAddNewCommissionPlanItemsSidebarActive,
      refetchCommissionPlansItemsData,
      isEditCommissionPlanItemsSidebarActive,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
